import StarBorderPurple500Icon from "@mui/icons-material/StarBorderPurple500"
import CakeIcon from "@mui/icons-material/Cake"
import EggIcon from "@mui/icons-material/Egg"
import RestaurantIcon from "@mui/icons-material/Restaurant"
import EmojiNatureIcon from "@mui/icons-material/EmojiNature"
import FavoriteIcon from "@mui/icons-material/Favorite"
import GrassIcon from "@mui/icons-material/Grass"
import OutdoorGrillIcon from "@mui/icons-material/OutdoorGrill"
import SoupKitchenIcon from "@mui/icons-material/SoupKitchen"
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment"
import SetMealIcon from "@mui/icons-material/SetMeal"
import KebabDiningIcon from "@mui/icons-material/KebabDining"

export const CATEGORIES_WITH_ICONS = [
  { name: "Featured", icon: <StarBorderPurple500Icon /> },
  { name: "Desserts", icon: <CakeIcon /> },
  { name: "Chicken", icon: <EggIcon /> },
  { name: "Beef", icon: <OutdoorGrillIcon /> },
  { name: "Pork", icon: <KebabDiningIcon /> },
  { name: "Fish", icon: <SetMealIcon /> },
  { name: "Pasta", icon: <RestaurantIcon /> },
  { name: "Vegetarian", icon: <EmojiNatureIcon /> },
  { name: "Healthy", icon: <FavoriteIcon /> },
  { name: "Salads", icon: <GrassIcon /> },
  { name: "Soups & Stews", icon: <SoupKitchenIcon /> },
  { name: "Spicy", icon: <LocalFireDepartmentIcon /> },
]

export const CATEGORIES = [
  "Featured",
  "Desserts",
  "Chicken",
  "Beef",
  "Pork",
  "Fish",
  "Pasta",
  "Vegetarian",
  "Healthy",
  "Salads",
  "Soups & Stews",
  "Spicy",
]

// Choose four (once we have that many ehe)
export const FEATURED_RECIPIE_IDS = [
  "66f5ed1ba060329c4094c4f7",
  "6707f9076e7ef2ab12716867",
  "6707fb126e7ef2ab12716868",
  "6707fd716e7ef2ab1271686b",
]

export const THEME_COLOURS = {}
